
import React from "react";
import { 
  PackageCheck, Palette, MessageCircle, Database, 
  AlertTriangle, TruckIcon, HammerIcon, BarChart3, FileText 
} from "lucide-react";

export interface ReportTab {
  id: string;
  label: string;
  icon: React.ReactNode;
}

export const reportTabs: ReportTab[] = [
  { id: 'naleveringen', label: 'Naleveringen', icon: <PackageCheck className="w-4 h-4" /> },
  { id: 'incidenten', label: 'Incidenten', icon: <AlertTriangle className="w-4 h-4" /> },
  { id: 'kleuren', label: 'Kleuren', icon: <Palette className="w-4 h-4" /> },
  { id: 'opmerkingen', label: 'Opmerkingen', icon: <MessageCircle className="w-4 h-4" /> },
  { id: 'voorraad', label: 'Voorraad', icon: <Database className="w-4 h-4" /> },
  { id: 'afwijkende-orders', label: 'Afwijkende orders', icon: <BarChart3 className="w-4 h-4" /> },
  { id: 'breuktransport', label: 'Breuktransport', icon: <TruckIcon className="w-4 h-4" /> },
  { id: 'schadeanalyse', label: 'Schadeanalyse', icon: <HammerIcon className="w-4 h-4" /> },
  { id: 'schaderapport', label: 'Schaderapport Q2', icon: <FileText className="w-4 h-4" /> },
];

export default reportTabs;
